<p-button
  [label]="label"
  [icon]="icon"
  [loading]="loading"
  [disabled]="disabled"
  [type]="type"
  [severity]="severity"
  [styleClass]="mergedStyleClass"
  (onClick)="handlePrimeClick($event)">
</p-button>
